// extracted by mini-css-extract-plugin
export var csatScore = "_lo-5";
export var header = "_lo-1";
export var panelWrapper = "_lo-2";
export var postPreview = "_lo-3";
export var rightContent = "_lo-0";
export var wrappingText = "_lo-4";